import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray } from '@angular/forms';
import { RecordTagSet, RecordTitleSet } from '@app/models/record.model';

@Component({
  selector: 'app-record-select-item',
  templateUrl: './record-select-item.component.html',
  styleUrls: ['./record-select-item.component.scss'],
})
export class RecordSelectItemComponent {
  @Input() expanded: boolean = false;
  @Input() titleTag!: RecordTagSet;
  @Input() titleSet!: RecordTitleSet;
  @Input() form!: FormArray;
  @Input('selectAll') forceSelectAll: boolean | undefined = false;
  @Output() formChange = new EventEmitter<FormArray>();
  formatName(name?: string) {
    return name?.replace(/(?<=#.*)#/g, '') || '';
  }

  get expandItem() {
    return this.expanded || (this.form.value as Array<boolean>).some(x=>x);
  }

  get selectedAll() {
    if ((this.form.value as any[]).every(v => v === null)) return false;
    return !(this.form.value as boolean[]).some(x => x === false || !x);
  }

  onSelectedAll(value?: boolean) {
    const currentState = value != null ? value : this.selectedAll;
    (this.form.controls).forEach(control => {
      control.setValue(!currentState);
    });
    this.onChange();
  }

  onChange(): void {
    this.formChange.emit(this.form);
  }
}
